/* eslint-disable react/no-unescaped-entities */
import Modal from '@common/modal';
import classnames from 'classnames/bind';
import styles from './applyNotice.module.scss';

const cx = classnames.bind(styles);

interface ApplyNoticeProps {
  isVisible: boolean;
  onClose: () => void;
}

const ApplyNotice = ({ isVisible, onClose }: ApplyNoticeProps) => {
  return (
    <Modal visible={isVisible} onClickBg={onClose}>
      <div className={cx('applyNotice')}>
        <span className={cx('subTitle')}>역량 기반의 취업 매칭 플랫폼</span>
        <strong className={cx('title')}>JOBDA로 통합 지원하기</strong>
        <span className={cx('description')}>
          통합 계정 하나로 750개 이상의 기업에 쉽게 지원할 수 있어요.
          <br />
          지원서 작성을 포함한 잡다의 다양한 맞춤형 취업 서비스를 받아보세요!
          <br />
          이제 취업의 모든 여정을 한 곳에서 관리하실 수 있습니다.
        </span>

        <img
          alt={
            '역검 응시 및 결과 활용, 인기기업 기출면접 연습, 지원서 불러오기, 나에게 딱 맞는 공고 추천, 지원현황 모아보기'
          }
          className={cx('img')}
          src={'/img/jobflex/imgService.png'}
        />

        <a className={cx('btn')} role="button" onClick={onClose}>
          확인
        </a>
      </div>
    </Modal>
  );
};

export default ApplyNotice;
